import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { MapPin } from 'lucide-react';
import { ACTIVE_BRANCH_KEY } from '../AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Franchise co-owner branch picker — lists only the branches assigned to them.
export default function BranchSwitcher({ collapsed = false }) {
  const [rows, setRows] = useState([]);
  const active = localStorage.getItem(ACTIVE_BRANCH_KEY) || '';

  useEffect(() => {
    axios.get(`${API}/branches`).then((r) => {
      const list = (r.data || []).filter((b) => b.active !== false);
      setRows(list);
      if (active && !list.some((b) => b.branch_id === active)) {
        localStorage.removeItem(ACTIVE_BRANCH_KEY);
        window.location.reload();
      }
    }).catch(() => setRows([]));
  }, [active]);

  const change = (v) => {
    if (v) localStorage.setItem(ACTIVE_BRANCH_KEY, v);
    else localStorage.removeItem(ACTIVE_BRANCH_KEY);
    window.location.reload();
  };

  if (collapsed) {
    return (
      <div className="mt-2 flex justify-center" title="Branch" data-testid="branch-switcher-collapsed">
        <MapPin size={14} className="text-orange-300" />
      </div>
    );
  }
  return (
    <label className="mt-2 block" data-testid="branch-switcher">
      <span className="text-[10px] uppercase tracking-wider text-slate-500 font-bold flex items-center gap-1 mb-1">
        <MapPin size={11} /> Branch
      </span>
      <select
        value={active}
        onChange={(e) => change(e.target.value)}
        data-testid="branch-switcher-select"
        className="w-full bg-white/5 ring-1 ring-white/10 text-white text-[12px] rounded-md px-2 py-1.5 focus:outline-none focus:ring-orange-400"
      >
        {rows.length > 1 && <option value="" className="text-slate-900">All my branches</option>}
        {rows.length === 1 && <option value="" className="text-slate-900">{rows[0].name}</option>}
        {rows.length > 1 && rows.map((b) => (
          <option key={b.branch_id} value={b.branch_id} className="text-slate-900" data-testid={`branch-switcher-option-${b.branch_id}`}>{b.name}</option>
        ))}
      </select>
    </label>
  );
}
